import type {CreateConnectionComponentProps} from '@cohort/wallet/apps';
import Button from '@cohort/wallet/components/button/Button';
import {Input} from '@cohort/wallet/components/forms/Input';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';

const InstagramCreateConnectionComponent: React.FC<CreateConnectionComponentProps> = ({
  isSubmitting,
  onSubmit,
}) => {
  const {t} = useTranslation('app-instagram', {
    keyPrefix: 'connector',
  });
  const [username, setUsername] = useState('');

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    onSubmit({
      username,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-6">
      <p className="text-sm">{t('description')}</p>
      <Input
        type="text"
        label={t('usernameLabel')}
        placeholder={t('usernamePlaceholder')}
        value={username}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUsername(e.target.value)}
        required
      />
      <Button
        type="submit"
        variant="primary"
        tracking={{namespace: 'apps.instagram.createConnection'}}
        loading={isSubmitting}
      >
        {t('buttonConnect')}
      </Button>
    </form>
  );
};

export default InstagramCreateConnectionComponent;
